var _defs, _polyline, _polyline2, _circle, _circle2, _animate, _animate2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClSquareLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.81 99.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n        .dot{\r\n            fill:#808285;\r\n        }\r\n        .base-line,.loading-line{\r\n            fill:none;\r\n            stroke-linecap:round;\r\n            stroke-miterlimit:10;\r\n        }\r\n        .base-line{\r\n            stroke:#808285;\r\n        }\r\n        .loading-line{\r\n            stroke:#f8992d;\r\n            stroke-width:3px;\r\n        }\r\n        #loading-line{\r\n            stroke-dasharray: 1400;\r\n            stroke-dashoffset: 1600;\r\n        }\r\n        #fill-dot{\r\n            visibility: hidden;\r\n            fill: #f8992d;\r\n        }\r\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "base-line",
    points: "1.5 1.5 1.5 98.31 99.31 98.31 99.31 1.5 10.17 1.5 10.17 89.83 91.02 89.83 91.02 9.2 19.17 9.2 19.17 80.76 81.2 80.76 81.2 19.06 27.65 19.06 27.65 71.98 71.54 71.98 71.54 27.24 35.91 27.24 35.91 63.72 63.83 63.72 63.83 36.76 48.91 36.76 48.91 49.91"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "loading-line",
    className: "loading-line",
    points: "1.5 1.5 1.5 98.31 99.31 98.31 99.31 1.5 10.17 1.5 10.17 89.83 91.02 89.83 91.02 9.2 19.17 9.2 19.17 80.76 81.2 80.76 81.2 19.06 27.65 19.06 27.65 71.98 71.54 71.98 71.54 27.24 35.91 27.24 35.91 63.72 63.83 63.72 63.83 36.76 48.91 36.76 48.91 49.91"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    className: "dot",
    cx: 48.91,
    cy: 48.2,
    r: 5.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "fill-dot",
    className: "dot",
    cx: 48.91,
    cy: 48.2,
    r: 5.88
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "loading-anim",
    xlinkHref: "#loading-line",
    attributeName: "stroke-dashoffset",
    values: "1400;500;0;0",
    keyTimes: "0;0.25;0.50;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "dot-anim",
    xlinkHref: "#fill-dot",
    attributeName: "visibility",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.45; 1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClSquareLoader);
export default __webpack_public_path__ + "static/media/cl-square-loader.107d7c2c22c6e54f5264c986e842be4e.svg";
export { ForwardRef as ReactComponent };